import { Facebook, Twitter, Instagram, Linkedin, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-abbella-ebony text-white pt-16 pb-8">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* About */}
          <div>
            <div className="flex items-center mb-4">
              <div className="h-8 w-8 mr-2">
                <img 
                  src="/lovable-uploads/57181b01-191c-43da-86d9-a331350c2776.png" 
                  alt="FlowCare Logo" 
                  className="h-full w-full object-contain brightness-0 invert"
                />
              </div>
              <h3 className="text-2xl font-bold">Flow<span className="text-abbella-aqua">Care</span></h3>
            </div>
            <p className="text-slate-300 mb-6">
              Revolutionizing home care with our flexible, no-minimum approach that puts you in control of your care journey.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Home</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">How It Works</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Our Services</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">About Us</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Stories</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Contact</a></li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Our Services</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Seniors Aging in Place</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Recovery Patients</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Family Caregivers</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Senior Housing Communities</a></li>
              <li><a href="#" className="text-slate-300 hover:text-abbella-aqua transition-colors">Employers</a></li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={20} className="text-abbella-aqua flex-shrink-0 mt-1" />
                <span className="text-slate-300">(410) 983-9942</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-abbella-aqua flex-shrink-0 mt-1" />
                <span className="text-slate-300">600 Owings Mills Blvd, Suite 440<br />Owings Mills, MD 21117</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-slate-800 flex flex-col items-center">
          {/* Abbella Logo */}
          <div className="mb-6">
            <img 
              src="/lovable-uploads/55f566ea-0dc8-4295-b1db-85212e35149d.png" 
              alt="Abbella Logo" 
              className="h-32 w-auto object-contain"
            />
          </div>
          
          <div className="text-center md:flex md:justify-between md:items-center w-full">
            <p className="text-slate-400 mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} FlowCare by Abbella. All rights reserved.
            </p>
            <div className="space-x-6">
              <a href="#" className="text-slate-400 hover:text-abbella-aqua transition-colors text-sm">Privacy Policy</a>
              <a href="#" className="text-slate-400 hover:text-abbella-aqua transition-colors text-sm">Terms of Service</a>
              <a href="#" className="text-slate-400 hover:text-abbella-aqua transition-colors text-sm">Accessibility</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
